export var exportToCSV = function (data, columnDelimiter, lineDelimiter) {
    if (data === void 0) { data = []; }
    if (columnDelimiter === void 0) { columnDelimiter = ','; }
    if (lineDelimiter === void 0) { lineDelimiter = '\n'; }
    var result = '';
    data.forEach(function (row) {
        var transformedRow = row.map(function (item) {
            if (item === null)
                return 'null';
            var hasDelimeter = typeof item === 'string' && item.includes(columnDelimiter);
            if (hasDelimeter)
                return "\"" + item + "\"";
            return item;
        });
        result += transformedRow.join(columnDelimiter) + lineDelimiter;
    });
    return result;
};
